import { Sx, Typography } from '@dhl/theme'

const classes: Record<string, Sx> = {
  title: (theme) => ({
    color: theme.palette.grey[500],
    background: theme.palette.grey[300],
    borderRadius: '5px',
    padding: theme.spacing(1),
    margin: `${theme.spacing(1.5)} auto`,
    width: 'fit-content',
  }),
}

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any
}

export const Title = ({ children }: Props) => (
  <Typography variant="h5" sx={classes.title}>
    {children}
  </Typography>
)
